import { VStack } from '@chakra-ui/react';

import { IconChevronDown, IconChevronTop } from '@/components/Icons';
import { CustomSortOrder } from '@/services/api';

type SortFilterProps<SortFilterColumns> = {
  onSortOrderChange: (
    newSortOrder: CustomSortOrder | null,
    sortColumnAffected: SortFilterColumns | null
  ) => void;
  currentSortOrder: CustomSortOrder | null;
  thisFiltersSortColumn: SortFilterColumns;
  activeSortColumn: SortFilterColumns | null;
};

export const SortFilter = <SortFilterItems,>({
  onSortOrderChange,
  currentSortOrder,
  thisFiltersSortColumn,
  activeSortColumn,
}: SortFilterProps<SortFilterItems>) => {
  const handleSortAscending = () => {
    const isDropping: boolean =
      activeSortColumn === thisFiltersSortColumn &&
      currentSortOrder === CustomSortOrder.Ascending;

    if (isDropping) {
      onSortOrderChange(null, null);
      return;
    }

    onSortOrderChange(CustomSortOrder.Ascending, thisFiltersSortColumn);
  };

  const handleSortDescending = () => {
    const isDropping: boolean =
      activeSortColumn === thisFiltersSortColumn &&
      currentSortOrder === CustomSortOrder.Descending;

    if (isDropping) {
      onSortOrderChange(null, null);
      return;
    }

    onSortOrderChange(CustomSortOrder.Descending, thisFiltersSortColumn);
  };

  const isAscendingActive: boolean =
    activeSortColumn === thisFiltersSortColumn &&
    currentSortOrder === CustomSortOrder.Ascending;

  const isDescendingActive: boolean =
    activeSortColumn === thisFiltersSortColumn &&
    currentSortOrder === CustomSortOrder.Descending;

  return (
    <VStack gap={0}>
      <IconChevronTop
        fontSize="10px"
        boxSize="10px"
        cursor="pointer"
        onClick={handleSortAscending}
        color={isAscendingActive ? 'brand.500' : undefined}
      />
      <IconChevronDown
        fontSize="10px"
        boxSize="10px"
        cursor="pointer"
        onClick={handleSortDescending}
        color={isDescendingActive ? 'brand.500' : undefined}
      />
    </VStack>
  );
};
